export default "__VITE_ASSET__a5691327__"